export default __webpack_public_path__ + "static/dominic_elm-d83ea34c4e4fad7689ea57d6b1e1e6cd.jpg";